// extracted by mini-css-extract-plugin
module.exports = {"marginHeader":"ForeignNational_marginHeader__1lAZi","headerForeign":"ForeignNational_headerForeign__2BU1j"};